function Counter1_0() {
  return <circle cx="8" cy="8" r="2.07895" stroke="#404040" strokeWidth="0.842105" />;
}

export default Counter1_0;
